import React, { useState } from 'react';
import { KeyboardArrowDown } from '@styled-icons/material/KeyboardArrowDown';
import { RadioButton } from '@naf-simba/elements-radio-button';
import { MembershipBoxAccordion } from '@components/MembershipBox/MembershipBoxAccordion/MembershipBoxAccordion';
import { MembershipBoxProps } from './MembershipBox.types';
import * as S from './MembershipBox.styles';

export const MembershipBox = ({
  id,
  title,
  price,
  hasBorder = false,
  showTag = false,
  benefitAccordions = [],
  selected,
  onSelect,
}: MembershipBoxProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleRadioClick = () => {
    onSelect(id);
  };

  const handleReadMoreClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  return (
    <S.BoxWrapper $hasBorder={hasBorder}>
      {showTag && <S.StyledTag text="Mest populær" color="secondary" />}
      <S.RadioContainer onClick={handleRadioClick}>
        <S.RadioWrapper>
          <RadioButton checked={selected} onChange={handleRadioClick} />
        </S.RadioWrapper>
        <S.ContentWrapper>
          <S.TitleText>{title}</S.TitleText>
        </S.ContentWrapper>
        {benefitAccordions.length > 0 && (
          <S.ReadMoreButton
            type="button"
            onClick={handleReadMoreClick}
            aria-label={isExpanded ? 'Vis mindre' : 'Les mer'}
          >
            <S.ChevronIcon $isOpen={isExpanded}>
              <KeyboardArrowDown size={24} />
            </S.ChevronIcon>
          </S.ReadMoreButton>
        )}
      </S.RadioContainer>

      {benefitAccordions.length > 0 && (
        <>
          {isExpanded && (
            <S.ExpandedContent>
              {benefitAccordions.map((accordion) => (
                <MembershipBoxAccordion
                  key={accordion.title}
                  title={accordion.title}
                  content={accordion.content}
                  variant={accordion.variant}
                  noBackground
                />
              ))}
            </S.ExpandedContent>
          )}

          <S.BottomSection>
            <S.PriceWrapper>{price && <S.Price>{price} kr for 12 måneder</S.Price>}</S.PriceWrapper>
          </S.BottomSection>
        </>
      )}
    </S.BoxWrapper>
  );
};

export const NoMembershipBox = ({
  id,
  title,
  selected,
  onSelect,
}: Pick<MembershipBoxProps, 'id' | 'title' | 'selected' | 'onSelect'>) => {
  const handleClick = () => {
    onSelect(id);
  };

  return (
    <S.SimpleBoxWrapper onClick={handleClick}>
      <S.RadioWrapper $leftPadding>
        <RadioButton checked={selected} onChange={handleClick} />
      </S.RadioWrapper>
      <S.ContentWrapper $leftMargin>
        <S.TitleText>{title}</S.TitleText>
      </S.ContentWrapper>
    </S.SimpleBoxWrapper>
  );
};
